<script>
  export let checked = false;
  export let color = '#2196F3';
  export let textColor = 'text-white';
  export let label;
</script>

<div class="flex flex-col">
  <label class="mt-3 inline-flex items-center cursor-pointer">
    <span class="relative">
      <span class="block w-10 h-6 bg-gray-300 rounded-full shadow-inner" />
      <span
        class="absolute block w-4 h-4 mt-1 mr-1 right-0 rounded-full shadow
        inset-y-0 focus-within:shadow-outline transition duration-700
        ease-in-out transform "
        class:bg-white={!checked}
        class:-translate-x-full={!checked}
        class:bg-blue-600={checked}>
        <input
          type="checkbox"
          class="absolute opacity-0 w-0 h-0"
          bind:checked />
      </span>
    </span>
    <span class="ml-3 text-sm font-bold">
      <span class={textColor}>{label}</span>
    </span>
    <span
      class="bg-white -translate-x-full text-white text-blue-600 bg-blue-600
      hidden" />
  </label>
</div>
